var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessoverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09466 14.5788C2.4201 14.9042 2.94774 14.9042 3.27317 14.5788L7.6717 10.1803L10.4076 12.9162C10.7331 13.2417 11.2607 13.2417 11.5861 12.9162L17.904 6.59837C18.2294 6.27293 18.2294 5.7453 17.904 5.41986C17.5785 5.09442 17.0509 5.09442 16.7255 5.41986L10.9969 11.1485L8.26095 8.41252C7.93551 8.08709 7.40788 8.08709 7.08244 8.41253L2.09466 13.4003C1.76923 13.7257 1.76923 14.2534 2.09466 14.5788Z",
    fill: "#161B2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.315 10.8327C17.7752 10.8327 18.1483 10.4596 18.1483 9.99938L18.1483 6.00916C18.1483 5.54893 17.7752 5.17583 17.315 5.17583L13.3248 5.17583C12.8645 5.17583 12.4915 5.54893 12.4915 6.00916C12.4915 6.4694 12.8646 6.8425 13.3248 6.8425L16.4817 6.8425V9.99938C16.4817 10.4596 16.8548 10.8327 17.315 10.8327Z",
    fill: "#161B2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessoverview);
export default __webpack_public_path__ + "static/media/businessoverview.234c024518113e2848e12f2619bc1d13.svg";
export { ForwardRef as ReactComponent };